import { TokenizedACHData } from '@/app/(app)/paymentMethods/achList';
import { TokenizedCreditCardData } from '@/app/(app)/paymentMethods/creditCardList';

export interface CreateNpoPaymentAccountParams {
  nonProfitOrgId: string;
  correlation_id: string;
  ach_correlation_id?: string;
  company: Company;
  owner_Principal: OwnerPrincipal;
  risk_profile: RiskProfile;
  bank: Bank;
}

export interface CreateNpoPaymentAccountStepsParams {
  nonProfitOrgId: string;
  acceptTos?: boolean;
  company?: Company;
  owner_Principal?: OwnerPrincipal;
  risk_profile?: RiskProfile;
  bank?: Bank;
}

export interface NpoPaymentAccountStepsResponse {
  files: {
    bucketPath: string;
    id: string;
  }[];
  result: NpoPaymentAccountStepsResult | null;
}

export interface NpoPaymentAccountStepsResult {
  acceptTOS: boolean;
  accountType?: string;
  achCorrelationId?: string;
  allStepsSaved: boolean;
  hasNuveiAccount: boolean;
  bankData?: Bank;
  bankSaved: boolean;
  companyData?: Company;
  companySaved: boolean;
  companySoftDescriptorData?: string;
  companySoftDescriptorSaved: boolean;
  correlationId?: string;
  docsUploadData?: any;
  docsUploadSaved: boolean;
  id: string;
  nonProfitOrgId: string;
  ownerPrincipalData?: OwnerPrincipal;
  ownerPrincipalSaved: boolean;
  riskProfileData?: RiskProfile;
  riskProfileSaved: boolean;
  uploadedMinReqFiles: boolean;
  userId: string;
}

export interface Company {
  company_legal_name: string;
  company_dba_name: string;
  company_soft_descriptor: string;
  company_ownership_type: string;
  company_federal_tax_id: string;
  company_url: string;
  company_mcc?: string;
  Customer_Support_Number: string;
  company_phone_number: string;
  legal_address: Address;
  dba_address: Address;
}

export interface Address {
  address: string;
  postal_code: string;
  city: string;
  state: string;
  country?: string;
}

export interface OwnerPrincipal {
  first_name: string;
  middle_name: string;
  last_name: string;
  email_address: string;
  phone: string;
  date_of_birth: string;
  social_security_number: string;
  drivers_license_number: string;
  address: Address;
  signing_manager: string;
}

export interface RiskProfile {
  average_transaction_amount: string;
  highest_ticket: string;
  monthly_processing_volume: string;
  average_check_amount: string;
  maximum_check_ach_amount: string;
  average_number_of_checks_per_month: string;
  monthly_check_volume: string;
  business_start_date: string;
}

export interface Bank {
  bank_routing_number: string;
  bank_account_number: string;
}

export interface GetTermsResponse {
  correlationId: string;
  termsAndConditionsId: string;
  termsAndConditionsURL: string;
}

export interface AcceptTermsResponse {
  correlationId: string;
  resellerKey: number;
  termsAndConditionsAccepted: boolean;
  termsAndConditionsId: string;
}

export interface PaymentMethodListResponse {
  paymentsafe_cards: PaymentSafeCard[];
  paymentsafe_checks: PaymentSafeCheck[];
  result: string;
  result_message: string;
}

export interface PaymentSafeCard {
  card_key: string;
  card_number_last_four_digits: string;
  card_type: string;
  expiration_date: string;
  name_on_card: string;
}

export interface PaymentSafeCheck {
  account_number_last_four_digits: string;
  account_type: string;
  check_key: string;
  check_type: string;
  name_on_check: string;
  secc_type: string;
}

export interface AddAchResponse {
  check_key: string;
  customer_key: string;
  gateway_id: string;
  reseller_id: string;
  result: string;
  result_message_1: string;
  result_message_2: string;
  username: string;
}

export interface AddCreditCardResponse {
  card_key: string;
  customer_key: string;
  gateway_id: string;
  reseller_id: string;
  result: string;
  result_message_1: string;
  result_message_2: string;
  username: string;
}

export interface ValidateAchResponse {
  aba: Aba;
  result: string;
  result_message: string;
}

export interface Aba {
  bank_name: string;
  routing_number: string;
}

// Subscriptions
export interface SubscriptionsListParams {
  n?: number;
  limit?: number;
}

export interface SubscriptionsListResponse {
  results: Subscription[];
  last: 'string';
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CLOSED = 'CLOSED',
  PENDING = 'PENDING'
}
export interface Subscription {
  amount: string;
  billingPeriod: string;
  contractCredentials: string;
  donationId: any;
  id: string;
  iv: string;
  n: string;
  nonProfitOrg: {
    name: string;
  };
  nonProfitOrgId: string;
  paymentType: 'CREDIT_CARD' | 'ACH';
  paymentTypeInfo: TokenizedACHData | TokenizedCreditCardData;
  startDate: string;
  dueDate: string;
  status: SubscriptionStatus;
  tag: string;
  transactionId: any;
  userId: string;
}

// Transactions
export interface TransactionsListParams {
  n?: number;
  limit?: number;
}

export interface TransactionsListResponse {
  results: Transaction[];
  last: 'string';
}
export interface Transaction {
  amount: number;
  createdAt: string;
  n: string;
  nonProfitOrgs: {
    id: string;
    name: string;
  };
  donorUser: {
    id: string;
    fullName: string;
  };
  paymentMethod: string;
  status: string;
  subscription: any;
  transactionId: string;
  updatedAt: string;
  surcharge?: number | null;
  notes?: string | null;
}

export interface GetTransactionHistoryPdfParams {
  limit?: number;
  dateFrom?: string;
  dateUntil?: string;
  year?: number;
  paymentMethod?: 'ACH' | 'CREDIT_CARD';
  state?: string;
}

export interface GetTransactionHistoryCsvParams {
  limit?: number;
  dateFrom?: string;
  dateUntil?: string;
  year?: number;
  paymentMethod?: 'ACH' | 'CREDIT_CARD';
  state?: string;
}
